<template>
  <PForm
    v-model="validado"
    @cancel="cancel"
    @accept="accept"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('label.cancelar')"
    class="form_VideosPlayForm"
  >
    <template #default="{}">
      <PRow>
        <PCol md="12">
          <PFormInputFile
            v-model="file"
            :label="$t('label.video')"
            rules="required"
            accept="video/*"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol col="6">
          <PFormDatepicker
            id="inputFechaVideo"
            v-model="valueLocal.fecha"
            :label="$t('label.fecha')"
            rules="required"
            :startSelector="inicioSeleccion"
            maxToday="true"
            :language="locale"
          />
        </PCol>
        <PCol col="6">
          <PFormSelect
            v-model="valueLocal.clienteId"
            :options="optionsClientes"
            optionValue="id"
            optionText="desCliente"
            :label="$t('label.cliente')"
            :placeholder="$t('option.select')"
            rules="required"
            @change="onChangeClient"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol col="6">
          <PFormSelect
            v-model="valueLocal.delegacionId"
            :options="delegations"
            optionValue="id"
            optionText="desDelegacion"
            :label="$t('label.delegacion')"
            :placeholder="$t('option.select')"
            rules="required"
            :disabled="delegations.length === 0"
            @change="getPuntos"
          />
        </PCol>
        <PCol md="6">
          <PFormSelect
            v-model="valueLocal.puntoServicioId"
            :options="puntos"
            optionValue="id"
            optionText="desPuntoservicio"
            :label="$t('label.puntoServicio')"
            :placeholder="$t('option.select')"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol col="6">
          <PFormInputText
            v-model="valueLocal.ciudad"
            :label="$t('label.ciudad')"
            id="inputCiudad"
          />
        </PCol>
        <PCol col="6">
          <PFormInputText
            v-model="valueLocal.sucursal"
            :label="$t('label.sucursal')"
            id="inputSucursal"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol col="6">
          <PFormDatepicker
            id="fechaNovedad"
            v-model="valueLocal.fechaNovedad"
            :label="$t('label.fechaNovedad')"
            rules="required"
            :language="locale"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol col="6">
          <PFormInputText
            v-model="valueLocal.nombreRevisores"
            :label="$t('label.nombreRevisor')"
            id="inputNombreRevisor"
          />
        </PCol>
        <PCol col="6">
          <PFormInputText
            v-model="valueLocal.cedulasCiudadania"
            :label="$t('label.cedulasCiudadania')"
            id="inputCedulasCiudadania"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol col="6">
          <PFormSelect
            v-model="valueLocal.tipoNovedadId"
            :options="optionTiposNovedad"
            optionValue="id"
            optionText="desParametro"
            :label="$t('label.tipoNovedad')"
            :placeholder="$t('option.select')"
          />
        </PCol>
        <PCol col="6">
          <PFormInputText
            v-model="valueLocal.importe"
            :label="$t('label.importe')"
            type="number"
            :min="0"
            id="inputImporte"
          />
        </PCol>
      </PRow>
      <PRow>
        <PCol md="12">
          <PFormInputText
            v-model="valueLocal.observaciones"
            :label="$t('label.observaciones')"
            type="textarea"
            id="inputObservaciones"
          />
        </PCol>
      </PRow>
    </template>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { iniVideoParams, IVideoParams } from "@/services";
import { ICliente, IClientexdel, IDelegacion, IParametro, IPuntoServicio } from "@/entities";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";

@Component({
  mixins: [VueMethods],
})
export class VideosUploadForm extends Vue {
  @Prop({ required: true }) value!: IVideoParams;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
  }

  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Prop({ required: true }) optionTiposNovedad!: IParametro[];
  @Getter("getLocale") locale!: Locale;
  @Getter("getClientesAll") getClientesAll!: ICliente[];
  @Getter("getClienteSelected") clienteSelected: ICliente | undefined;
  public delegations: IDelegacion[] = [];
  public puntos: IPuntoServicio[] = [];
  validado = false;
  valueLocal = iniVideoParams;
  optionsClientes: ICliente[] = [];
  file: File | null = null;
  inicioSeleccion = new Date(1900, 0, 1);
  private cliente: ICliente | undefined = undefined;
  private static readonly SORTBY_DELEGATIONS: string = "desDelegacion";
  private static readonly SORTBY_PUNTOS: string = "desPuntoservicio";

  mounted(): void {
    this.optionsClientes = this.getClientesAll;
    if (this.clienteSelected) {
      this.valueLocal.clienteId = this.clienteSelected?.id;
      this.onChangeClient();
    }
  }

  async onChangeClient(): Promise<void> {
    if (this.valueLocal.clienteId) {
      let aux = await this.$services.clientes._fetchCliente(Number(this.valueLocal.clienteId));
      if (aux) {
        this.cliente = aux;
        this.limpiar();
        this.getDelegations();
      }
    }
  }

  limpiar(): void {
    this.valueLocal.delegacionId = null;
    this.valueLocal.puntoServicioId = null;
    this.delegations = [];
    this.puntos = [];
  }

  getDelegations(): void {
    const d: IDelegacion[] = [];
    if (this.cliente && this.cliente?.clientexdels) {
      this.cliente?.clientexdels.forEach((clientexdel) => {
        if (clientexdel?.delegacion && clientexdel?.active) {
          d.push(clientexdel.delegacion);
        }
      });
      this.delegations = d.sort((a, b) =>
        this.sortAscending(a, b, VideosUploadForm.SORTBY_DELEGATIONS)
      );
    }
  }

  getPuntos(): void {
    this.valueLocal.puntoServicioId = null;
    this.puntos = [];
    if (this.cliente != undefined) {
      let cxds = this.cliente.clientexdels;
      if (this.valueLocal.delegacionId) {
        cxds = cxds?.filter(
          (cxd: IClientexdel) => this.valueLocal.delegacionId == cxd.delegacion?.id
        );
      }
      cxds?.forEach((cxd) =>
        this.puntos.push(
          ...(cxd.puntosservicio.sort((a, b) =>
            this.sortAscending(a, b, VideosUploadForm.SORTBY_PUNTOS)
          ) || [])
        )
      );
    }
  }

  accept(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { data: this.valueLocal, action: action, file: this.file });
  }
  cancel(): void {
    this.$emit("cancel", { data: this.valueLocal, action: "cancel" });
  }
}

export default VideosUploadForm;
</script>
<style scoped>
.form_VideosPlayForm {
  padding: 1rem;
}
</style>
